const ssiEventUnhandledrejection: string = "unhandledrejection";
const ssiUnhandledrejectionCount: string = ssiEventUnhandledrejection + "-count";
const ssiUnhandledrejectionBase: string = ssiEventUnhandledrejection + "-";

// ReSharper disable once Html.EventNotResolved
window.addEventListener(ssiEventUnhandledrejection, (event: PromiseRejectionEvent) => {
    try {
        let count = (window as any).localStorage.getItem(ssiUnhandledrejectionCount);
        if (count === "" || count === "NaN" || !count) {
            count = "1";
        }
        let countX = parseInt(count, 10);
        if (isNaN(count) || countX < 1) {
            countX = 1;
        } else {
            countX += 1;
        }
        (window as any).localStorage.setItem(ssiUnhandledrejectionCount, countX);
        (window as any).localStorage.setItem(`${ssiUnhandledrejectionBase}${countX}`, event.reason);
    } catch (ex) {
        if (console.error !== null) {
            console.error(`unhandled rejection ex: ${ex}`);
        } else {
            console.log(`unhandled rejection ex: ${ex}`);
        }
        return;
    }
    if (console.error !== null) {
        console.error(`unhandled promise rejection: ${event.reason}`);
    } else {
        console.log(`unhandled promise rejection: ${event.reason}`);
    }
});

namespace SSi.Blazor.Common.Shared.Wasm {

    export function clearUnhandledRejections() {
        try {

            const count = getUnhandledRejectionCount();
            if (count > 0) {
                for (let i = 1; i <= count; i++) {
                    try {
                        (window as any).localStorage.removeItem(`${ssiUnhandledrejectionBase}${i}`);
                    } catch (ex1) {
                        console.error(`removeItem ex: ${ex1}`);
                    }
                }
            }
            try {
                (window as any).localStorage.removeItem(ssiUnhandledrejectionCount);
            } catch (ex2) {
                console.error(`removeItem ex: ${ex2}`);
            }

        } catch (ex) {
            console.error(`unhandled rejection count ex: ${ex}`);
        }
    }

    export function getUnhandledRejectionCount(): number {
        try {
            let count = (window as any).localStorage.getItem(ssiUnhandledrejectionCount);
            if (count === "") {
                count = "1";
            }
            let countX = parseInt(count, 10);
            if (countX < 1) {
                countX = 0;
            }
            return countX;
        } catch (ex) {
            console.error(`unhandled rejection count ex: ${ex}`);
        }
        return 0;
    }

    export function hasUnhandledRejections(): boolean {
        try {
            return getUnhandledRejectionCount() > 0;
        } catch (ex) {
            console.error(`has unhandled rejection ex: ${ex}`);
        }
        return false;
    }


    export function getUnhandledRejections(): string {
        try {
            var value = "";
            let count = getUnhandledRejectionCount();
            if (count > 0) {
                for (var i = 1; i < count; i++) {
                    var line = getUnhandledRejection(i);
                    if (line !== "") {
                        value += line + "\r\n";
                    }
                }
            }

            return value;
        } catch (ex) {
            console.error(`unhandled rejection value ex: ${ex}`);
        }
        return "";
    }

    export function getUnhandledRejection(index: number): string {
        try {
            let value = (window as any).localStorage.getItem(`${ssiUnhandledrejectionBase}${index}`);
            return value;
        } catch (ex) {
            console.error(`unhandled rejection value ex: ${ex}`);
        }
        return "";
    }

    // ReSharper disable once InconsistentNaming
    export function isInstalledAsPwa(): boolean {
        // For iOS
        //if (window.navigator.standalone) 
        if (("standalone" in window.navigator) && (window.navigator["standalone"] === true))
            return true;

        // For Android
        if (window.matchMedia('(display-mode: standalone)').matches)
            return true;

        // If neither is true, it's not installed
        return false;
    }
}
